import React from "react"
import useFormField from "../../../../hooks/useFormField"
import FormFieldError from "../labels/form-field-error"
import FormInputLabel from "../labels/form-field-label"
import ToggleInfo from "../buttons/toggle-info-button"

export default function SelectionMultiInput({
  name,
  id,
  label,
  options = [],
  placeholder,
  required,
  description,
  validateField,
  globalValue,
  setGlobalValue,
  setError,
  error,
  displayOption,
  closeModalLabel,
  moreInfoLabel,
}) {
  const initialCheckedValues = options.filter((option) => option.checked).map((option) => option.value)
  const { value, isFocused, handleFocus, handleBlur, handleChange } = useFormField(
    initialCheckedValues,
    validateField,
    globalValue,
    setGlobalValue,
    setError,
  )

  const handleSelectChange = (e) => {
    const newValue = Array.from(e.target.selectedOptions, (option) => option.value)
    handleChange({ target: { value: newValue } })
  }

  return (
    <div
      className={`form-element form-element--select__multi is-bound Form__Element ${displayOption} ${placeholder || value || isFocused ? "is-filled" : ""} ${
        isFocused ? "has-focus" : ""
      } ${required ? "is-required" : ""} ${error ? "is-invalid" : ""}`}
      data-f-element-name={name}
      data-f-type="selection"
    >
      <div className="form-container">
        <div className="form-labels">
          <FormInputLabel id={id} label={label} required={required} />
          <ToggleInfo description={description} id={id} closeModalLabel={closeModalLabel} moreInfoLabel={moreInfoLabel} />
        </div>
        <select
          name={name}
          id={id}
          className="form-input"
          required={required}
          aria-required={required}
          multiple
          data-f-datainput=""
          aria-describedby={`${name}_desc`}
          value={value}
          onFocus={handleFocus}
          onBlur={handleBlur}
          onChange={handleSelectChange}
          title={description}
          aria-label={description + (placeholder != null ? " " + placeholder : "")}
          aria-invalid={!!error}
        >
          {options.map((option, index) => (
            <option key={index} value={option.value} data-f-default-value={option.checked}>
              {option.label}
            </option>
          ))}
        </select>
      </div>
      <FormFieldError name={name} error={error} placeholder={placeholder} />
    </div>
  )
}
